<template>
  <div class="choose_wx_group_box">
    <el-dialog    @open="onDialogOpen" v-bind="$attrs" title="选择群" width="80%" destroy-on-close :close-on-click-modal="false">
      <div v-loading="searchFormIniting">
        <LoadError v-if="searchFormInitError" :msg="searchFormInitErrorMsg" @retry="retrySearchFormDataInit" />
        <div class="choose_content_box" v-else>
          <div class="condition_box">
            <el-space wrap>
              <!-- 班级类型搜索框 -->
              <el-select v-model="classType" placeholder="请选择班级" style="width: 130px"
                @change="onClassTypeChange">
                <el-option v-for="item in classTypeList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <!-- 班级搜索框 -->
              <el-select v-if="classType != 3" v-model="classInfo.classCode_groupClassNo" filterable placeholder="请选择班级" style="width: 300px"
                @change="onClassCodeChange">
                <el-option v-if="classCodeList.length==0" key='__' label="暂无对应班级" value="__"></el-option>
                <el-option v-for="item in classCodeList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <!-- 学习机大组使用 -->
              <el-select v-if="classType == 1" v-model="learnMachineType" placeholder="选择组状态" style="width: 100px"
                :clearable="true" @change="onLearnMachineTypeChange">
                <el-option v-for="item in learnMachineGroupTypes" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
              <!-- 学习机小组使用 -->
              <!-- <el-select v-if="classType == 2" v-model="learnMachineType" placeholder="选择组状态" style="width: 100px"
                :clearable="true" @change="onLearnMachineTypeChange">
                <el-option v-for="item in learnMachineSmallGroupTypes" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select> -->
              <el-select v-if="classType == 3" v-model="one2oneType" placeholder="根据在读状态选择" style="width: 100px"
                :clearable="true" @change="onOne2oneTypeChange">
                <el-option v-for="item in one2oneTypes" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>

              <!-- 分组搜索框 -->
              <el-select v-if="classType != 3" v-model="groupId" :disabled="groupList.length == 0" placeholder="请选择分组" style="width: 200px"
                @change="onGroupChange">
                <el-option  key="" label="全部分组" value="" />
                <el-option v-for="item in groupList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <!-- 姓名搜索框 -->
              <el-input v-model.trim="studentSearchName" style="width: 220px" placeholder="请输入学员姓名或昵称或微信"
                @input="onStudentNameChange" />
            </el-space>
          </div>
          <div class="table_top_tip">
            <h3 style="color:#333">学员列表：<span style="font-size: 12px">当前列表下：已选{{ multipleSelection.length }}人,未选 {{ tableData.length > multipleSelection.length ? tableData.length - multipleSelection.length : 0}}人</span></h3>
            <div>
              <el-icon size='15px' class="top3">
                <WarningFilled />
              </el-icon>
              请先绑定接收消息的微信群，否则该学员无法被选中！
            </div>
          </div>
          <el-table stripe ref="tableRef" :data="tableData" @selection-change="handleTableSelectionChange"
            :border='true' v-loading="tableDataLoading" height="50vh" row-key="studentCode" @cell-click="changeSelectState">
            <el-table-column type="selection" width="50" :selectable="rowSelectable" :reserve-selection="true" />
            <el-table-column property="studentCode" label="学生编码" width="150" />
            <el-table-column property="studentName" label="学员姓名" width="150" />
            <el-table-column property="nickName" min-width="180">
              <template #header>
                <span>沟通称呼语</span>
                <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="是发送企微私聊/群聊时，对学生本人/家长的称呼，设置后发送任务时可以自动读取"
                  placement="top"
                >
                  <el-icon class="top3"><InfoFilled color="#67C23A" /></el-icon>
                </el-tooltip>
              </template>
              <template #default="scope">
                <NicknameInput v-if="scope.row.isEditState" v-model="scope.row.nickName" :student-code="scope.row.studentCode"></NicknameInput>
                <span v-else>{{ scope.row.nickName }}</span>
              </template>
            </el-table-column>
            <el-table-column property="receiveName" min-width="180">
              <template #header>
                <span>绑定沟通群聊</span>
                <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="绑定沟通的微信群/企微群，用于接收群发消息，每个学员仅支持绑定一个微信群"
                  placement="top"
                >
                  <el-icon class="top3"><InfoFilled  color="#67C23A"/></el-icon>
                </el-tooltip>
              </template>
              <template #default="scope">
                <el-tooltip :disabled="!scope.row.receiveName" effect="dark" :content="scope.row.receiveName" placement="top">
                  <wxGroupNameSelect v-if="scope.row.isEditState" v-model="scope.row.receiveName" :student-code="scope.row.studentCode" placeholder="请绑定学员服务群" @change="receiveNameChange(scope.row)"></wxGroupNameSelect>
                  <span v-else>{{ scope.row.receiveName }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column v-if="classType != 2" label="分组" min-width="180" show-overflow-tooltip>
            
              <template #default="scope">
                <div class="fenzu_box">
                  <el-space wrap><el-tag type="info" v-for="item in scope.row.groupList" :key="item.groupId">{{item.groupName}}</el-tag></el-space>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" fixed="right" align="center">
              <template #default="scope">
                <el-tooltip v-if="!scope.row.isEditState" content="开启更改模式" placement="top">
                  <el-icon @click="startEditState(scope.row)"><Edit /></el-icon>
                </el-tooltip>
                <el-tooltip v-else content="完成更改" placement="top">
                  <el-icon @click="closeEditState(scope.row)"><Finished /></el-icon>
                </el-tooltip>
              </template>
            </el-table-column>
            <template #empty>
              <LoadError v-if="tableDataLoadError" :msg="tableDataLoadErrorMsg" @retry="retryGetStudentList" />
              <span v-else-if="!tableDataLoading">暂无数据</span>
              <span></span>
            </template>
          </el-table>
        </div>
      </div>
      <template v-if="showFooter" #footer>
        <div class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="confirm">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import LoadError from '@/components/loadError'
import { getGroupListByClass, getLearnMachineGroupList, getLearnMachineSmallGroupList, getStudentListByClass, getLearnMachineStudentList, getLearnMachineSmallStudentList, getOne2OneStudentList } from '@/api/common.js'
import { reactive, ref,nextTick, computed } from 'vue'
import { useClassListStore } from '@/store/classList'
import wxGroupNameSelect from '@/components/wxGroupNameSelect.vue'
import NicknameInput from '@/components/nicknameInput.vue'
import { sortByName } from '@/utils/util'
import {learnMachineGroupTypes,learnMachineSmallGroupTypes,one2oneTypes,classListOption} from '@/constants/options'
const classStore = useClassListStore();
const emit = defineEmits(['confirm', 'cancel'])
const props = defineProps({
  choosedList:{
    default:()=>([])
  }
})
const tableRef = ref();

const one2oneType = ref(1);

const classInfo = reactive({
  classCode_groupClassNo: '',
  schoolId: '',
  groupClassNo: ''
});
const groupId = ref('');
const studentSearchName = ref('');
const multipleSelection = ref([]);
const groupList = ref([])


const searchFormIniting = ref(true);
const searchFormInitError = ref(false);
const searchFormInitErrorMsg = ref('');


const classTypeList = classStore.classTypeList;
const classType = ref(classTypeList[0]?.value || 0);


const learnMachineType = ref(1) //学习机大组的的在组是2 小组的在组是1； 有点麻烦

const tableData = ref([]);
let originalTableData = [];// 原始数据 方便前端自己搜索
const classCodeList = ref([])
const tableDataLoading = ref(false);
const tableDataLoadError = ref(false);
const tableDataLoadErrorMsg = ref('');
let originalSelectedList = [];



const showFooter = computed(() => {
  return !searchFormIniting.value && !searchFormInitError.value && !tableDataLoading.value && !tableDataLoadError.value
})

const updateLearnMachineType = ()=>{
  //学习机大组的的在组是2 小组的在组是1； 有点麻烦
  if(classType.value == 1){ 
    learnMachineType.value = 2;
  }else if(classType.value == 2){
    learnMachineType.value = 1;
  }
}
// 回显表格已选中的数据
const updateSelectedRows = () => {
  originalSelectedList = [];
  tableRef.value?.clearSelection()
  tableRef.value.$nextTick(() => {
    tableData.value.forEach((row) => {
      if (props.choosedList.some(item=>item.studentCode == row.studentCode)) {
        tableRef.value.toggleRowSelection(row, true);
      }
    });
    originalSelectedList = [...multipleSelection.value];
  });
};

// 更改选中状态
const changeSelectState = (row,cellData)=>{
  console.log(666666,cellData) 
  if(cellData.type == 'selection' || cellData.property == 'studentCode'){
    if(multipleSelection.value.some(item=>item.studentCode == row.studentCode)){
      tableRef.value.toggleRowSelection(row, false);
    }else{
      tableRef.value.toggleRowSelection(row, true);
    }
    
  }
}


const rowSelectable = (row) => {
  // console.log(row)
  if (row.receiveName) {
    return true
  }
  return false
}
const handleTableSelectionChange = (val) => {
// TODO 添加过滤功能？
  multipleSelection.value = val
}

const onDialogOpen = () => {
  searchFormInit()
}

const retrySearchFormDataInit = () => {
  searchFormInit();
}
const searchFormInit = () => {
  searchFormIniting.value = true;
  searchFormInitError.value = false;
  updateLearnMachineType()
  if(classType.value == 0){
    // 班课
    classCodeList.value = classStore.classList.map(item => {
      return {
        value: item.classCode+"__"+item.groupClassNo,
        label: item.className + `(${item.classCode || groupCode})`,
        schoolId: item.schoolId
      }
    })
    classInfo.classCode_groupClassNo = classStore.defaultClass?.classCode+'__'+classStore.defaultClass?.groupClassNo;
    classInfo.schoolId = classStore.defaultClass?.schoolId;
    classInfo.groupClassNo = classStore.defaultClass?.groupClassNo;
  } else if(classType.value == 1){
    // 学习机大组
    classCodeList.value = classStore.learnMachineClassList.map(item => {
      return {
        value: item.classCode+"__"+item.groupClassNo,
        label: item.className + `(${item.classCode || groupCode})`,
        schoolId: item.schoolId
      }
    })
    classInfo.classCode_groupClassNo = classStore.defaultLearnMachineClass?.classCode+'__'+classStore.defaultLearnMachineClass?.groupClassNo;
    classInfo.schoolId = classStore.defaultLearnMachineClass?.schoolId;
    classInfo.groupClassNo = classStore.defaultLearnMachineClass?.groupClassNo;
    classInfo.groupCode = classStore.defaultLearnMachineClass?.groupCode;
  }else if(classType.value == 2){
    // 学习机小组
    classCodeList.value = classStore.learnMachineSmallClassList.map(item => {
      return {
        value: item.classCode+"__"+item.groupClassNo,
        label: item.className + `(${item.classCode || groupCode})`,
        schoolId: item.schoolId
      }
    })
    classInfo.classCode_groupClassNo = classStore.defaultLearnMachineSmallClass?.classCode+'__'+classStore.defaultLearnMachineSmallClass?.groupClassNo;
    classInfo.schoolId = classStore.defaultLearnMachineSmallClass?.schoolId;
    classInfo.groupClassNo = classStore.defaultLearnMachineSmallClass?.groupClassNo;
    classInfo.groupCode = classStore.defaultLearnMachineSmallClass?.groupCode;
  }else{
    // 个性化
    getStudentList()
  }
  if(!classInfo.classCode_groupClassNo){
    // 没有对应的班级的话就不用再去请求分组和列表数据了
    tableData.value = [];
    groupList.value = [];
    searchFormIniting.value = false;
    return;
  }
  getGroupList();
}

const retryGetStudentList = () => {
  getStudentList()
}
const getStudentListApi = ()=>{
  if(classType.value == 0){
    // 班课
    let [classCode,groupClassNo] = classInfo.classCode_groupClassNo.split('__');
    return getStudentListByClass({
      classCode: classCode,
      groupClassNo: groupClassNo == 'null' ? '' : groupClassNo,
      schoolId: classInfo.schoolId,
      groupId: groupId.value
    })
  }else if(classType.value == 1){
    // 学习机
    let [classCode,groupClassNo] = classInfo.classCode_groupClassNo.split('__');
    return getLearnMachineStudentList({
      learnMachineGroupCode: classCode,
      schoolId: classInfo.schoolId,
      stuInStatus: learnMachineType.value,
      groupId: groupId.value
    })
  }else if(classType.value == 2){
    // 学习机小组
    let [classCode,groupClassNo] = classInfo.classCode_groupClassNo.split('__');
    return getLearnMachineSmallStudentList({
      subGroupCode: classCode,
      schoolId: classInfo.schoolId,
      stuInStatus: 1,
      groupId: groupId.value
    })
  }else{
    // 一对一  TODO
    return getOne2OneStudentList({
      classStatus: one2oneType.value
    })
  }
}

const getStudentList = () => {
  tableDataLoading.value = true;
  tableDataLoadError.value = false;
  tableData.value = [];
  getStudentListApi().then(res => {
    tableDataLoading.value = false;
    originalTableData = res.map(item => {
      return {
        studentName: item.studentName,
        studentCode: item.studentCode,
        nickName: item.nickName,
        receiveId: item.chatId,
        receiveName: item.weChatGroupName || '',
        receiveNameSelectList: [],
        groupList: item.groupList || [],
        wechatBasicInfo:item.wechatBasicInfo || {}
      }
    })
    originalTableData = sortByName(originalTableData);
    tableData.value = [...originalTableData];
    nextTick(()=>{
      updateSelectedRows();
    })
  }).catch(err => {
    tableData.value = [];
    tableDataLoading.value = false;
    tableDataLoadError.value = true;
    tableDataLoadErrorMsg.value = err?.toString();
  })
}
const getGroupListApi = ()=>{
  let [classCode,groupClassNo] = classInfo.classCode_groupClassNo.split('__');
  if(classType.value == 0){
    // 班课
    return getGroupListByClass({
      classCode: classCode,
      groupClassNo: groupClassNo == 'null' ? '' : groupClassNo,
      schoolId: classInfo.schoolId
    }) 
  }else if(classType.value == 1){
    // 学习机大组
    return getLearnMachineGroupList({
      learnMachineGroupCode: classCode,
      schoolId: classInfo.schoolId
    })
  }else if(classType.value == 2){
    // 学习机小组
    return getLearnMachineSmallGroupList({
      subGroupCode: classCode,
      schoolId: classInfo.schoolId
    })
  }else{
    // 个性化 没有分组
    return Promise.resolve([])
  }
}
const getGroupList = ()=>{
  getGroupListApi().then(res => {
    searchFormIniting.value = false;
    if (res) {
      // groupId.value = res[0].groupId;
      groupList.value = res.map(item => {
        return {
          label: item.groupName,
          value: item.groupId
        }
      })
    }
    getStudentList()
  }).catch(err => {
    searchFormIniting.value = false;
    searchFormInitError.value = true;
    searchFormInitErrorMsg.value = err?.toString();
  })
}


const onClassTypeChange = ()=>{
  // classInfo.classCode = classCodeList.value[0].value
  groupId.value ='';
  classInfo.classCode_groupClassNo = '';
  searchFormInit()
}

const onClassCodeChange = (classCode) => {
  updateLearnMachineType()
  const currentClass = classCodeList.value.filter(item => item.value == classCode)[0];
  classInfo.schoolId = currentClass.schoolId;
  classInfo.groupClassNo = currentClass.groupClassNo;
  classInfo.groupCode = currentClass.groupCode;
  groupId.value = '';
  studentSearchName.value = '';
  getGroupList()
}
const onLearnMachineTypeChange = ()=>{
  studentSearchName.value = '';
  getStudentList()
}
const onOne2oneTypeChange = ()=>{
  studentSearchName.value = '';
  getStudentList()
}
const onGroupChange = () => {
  studentSearchName.value = '';
  getStudentList()
}
const onStudentNameChange = (v = '') => {
  if(v.trim().length == 0)return;
  tableData.value = originalTableData.filter(item => {
    return item.studentName.indexOf(v) > -1 || item.nickName?.indexOf(v) > -1 || item.receiveGroupName?.indexOf(v) > -1 || item.studentCode?.indexOf(v) > -1;
  })
}



const startEditState = (row)=>{
  row.isEditState = true
}
const closeEditState = (row)=>{
  row.isEditState = false
  // 完成编辑的时候 若去除绑定的微信 则 自动移除这个人
  if(row.receiveName.trim() == ''){
    tableRef.value.toggleRowSelection(row, false);
  }
}
const receiveNameChange = (row)=>{
  if(!row.receiveName || row.receiveName.trim() == ''){
    tableRef.value.toggleRowSelection(row, false);
  }
}


const cancel = () => {
  emit('cancel')
}
const confirm = () => {
  const addStudents = [];// 新的数组有，老数组没有
  const deleteStudents = [];// 新的没有 老的有   新的有。老得也有 不管
  multipleSelection.value.forEach(newItem=>{
    if(!originalSelectedList.some(oldItem=> newItem.studentCode == oldItem.studentCode)){
      addStudents.push(newItem)
    }
  })
  originalSelectedList.forEach(oldItem=>{
    if(!multipleSelection.value.some(newItem=>newItem.studentCode == oldItem.studentCode)){
      deleteStudents.push(oldItem)
    }
  })
  emit('confirm', {
    addStudents:addStudents,
    deleteStudents:deleteStudents
  })
}

</script>

<style lang="less" scoped>
.choose_wx_group_box {

  .condition_box {
    
    border-top: 1px solid #fefefe;
    border-bottom: 1px solid #fefefe;

  }
  :deep(.el-autocomplete){
    width: 100%;
  }

  :deep(.el-loading-mask) {
    z-index: 999999;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>